module.exports = __webpack_public_path__ + "img/yousa-bg.4e293a38.jpg";